<template>
  <div>
    <headers />
    <div class="banner containers clearfix" @mouseleave="fenleiremoveActive(-1)">
      <div class="spanlist fl clearfix">
        <span
          v-for="(item , index) in fenlei"
          :key="item.id"
          :data-id="item.id"
          @mouseover="fenleiActive(index)"
        >
          <em>{{item.title}}</em>

          <i class="el-icon-arrow-right"></i>
        </span>
      </div>
      <div
        class="coner"
        v-for="(item , index) in fenlei"
        :key="item.id"
        :data-id="item.id"
        v-if="index == fenleiindex"
        @mouseout="fenleiActive(index)"
        @mouseleave="fenleiremoveActive(-1)"
      >
        <div class="conernei">
          <div class="conert">
            <h3>{{item.title}}</h3>
            <div class="alist clearfix">
              <router-link
                tag="em"
                :to="{path:'/classlistarr',query:{daid:item.id,xiaoid:items.id}}"
                v-for="(items) in item.child"
                :key="items.id"
                :data-id="items.id"
              >{{items.title}}</router-link>
            </div>
          </div>
          <div class="conerb">
            <dl class="clearfix">
              <router-link
                tag="dd"
                class="clearfix"
                v-for="(items) in item.course"
                :key="items.id"
                :data-id="items.id"
                :to="{path:'/detailsclass',query:{id:items.id}}"
              >
                <div class="pic">
                  <img :src="items.imgUrl" alt srcset />
                </div>
                <div class="infos">
                  <h4>{{items.title}}</h4>
                  <div class="numbox">
                    {{items.price==0?'免费':'¥'+items.price}} · {{items.sectionCount}}课程 ·
                    <i
                      class="el-icon-coordinate"
                      style="float:none"
                    ></i>
                    {{items.count}}
                  </div>
                </div>
              </router-link>
            </dl>
          </div>
        </div>
      </div>

      <div class="main fr">
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="(item,index) in indexdata.banner" :key="index">
            <img :src="item.imgUrl" alt srcset @click="bannerto(item.type,item.value)" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="lately" v-if="indexdata.live">
      <div class="containers">
        <h2 class="indextitle">
          最近直播
          <span>好课直播不要错过</span>
        </h2>
        <div class="swiper-container" ref="live">
          <ul class="clearfix swiper-wrapper">
            <router-link
              tag="div"
              :to="{path:'/detailsclass',query:{id:item.id}}"
              class="swiper-slide"
              v-for="(item) in indexdata.live"
              :data-id="item.id"
              :key="item.id"
            >
              <li class="clearfix">
                <div class="infos">
                  <div class="time">{{item.beginDate}}</div>
                  <h3>{{item.title}}</h3>
                  <div class="name">{{item.teacher.name}}</div>
                  <div class="nus">
                    <span class="money">{{item.price == 0?'免费':'¥'+item.price}}</span>
                    <span class="people">
                      <i class="el-icon-user-solid"></i>
                      {{item.count}}人在学
                    </span>
                  </div>
                </div>
                <div class="pic">
                  <img :src="item.teacher.avatar" alt srcset />
                </div>
                <!-- 1未开始 2直播中 3直播结束 -->
                <div class="type" v-if="item.state == 1">未开始</div>
                <div class="type" v-if="item.state == 2">直播中</div>
                <div class="type" v-if="item.state == 3">直播结束</div>
              </li>
            </router-link>
          </ul>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        <!-- <div class="imglist clearfix">
          <img src="http://web.wit100.net/yunmipcimg/img_11.jpg" alt srcset />
          <img src="http://web.wit100.net/yunmipcimg/img_13.jpg" alt srcset />
          <img src="http://web.wit100.net/yunmipcimg/img_15.jpg" alt srcset />
        </div>-->
      </div>
    </div>

    <div class="selectedclass" v-if="indexdata.recommend">
      <div class="containers">
        <h2 class="indextitle">
          精选课程
          <span>精选课程丰富内容</span>
        </h2>
        <ul class="pubilcul clearfix">
          <router-link
            tag="li"
            :to="{path:'/detailsclass',query:{id:item.id}}"
            v-for="(item) in indexdata.recommend"
            :key="item.id"
            :data-id="item.id"
          >
            <div class="pic">
              <img :src="item.imgUrl" alt srcset />
            </div>
            <div class="infos">
              <h3>{{item.title}}</h3>
              <div class="spans clearfix">
                <span class="money">{{item.price == 0?'免费':'¥'+item.price}}</span>
                <span class="number">
                  <i class="el-icon-user-solid"></i>
                  {{item.count}}
                </span>
              </div>
            </div>
          </router-link>
        </ul>
      </div>
    </div>

    <div class="newclass" v-if="indexdata.newCourse">
      <div class="containers">
        <h2 class="newtitle">最新课程</h2>
        <ul class="pubilcul clearfix on">
          <router-link
            tag="li"
            :to="{path:'/detailsclass',query:{id:item.id}}"
            v-for="(item) in indexdata.newCourse"
            :key="item.id"
            :data-id="item.id"
          >
            <div class="pic">
              <img :src="item.imgUrl" alt srcset />
              <!--1点播课 2直播课 3线下课-->
              <div v-if="item.type==1" class="type">点播课</div>
              <div v-if="item.type==2" class="type">直播课</div>
              <div v-if="item.type==3" class="type">线下课</div>
            </div>
            <div class="infos">
              <h3>{{item.title}}</h3>
              <div class="spans clearfix">
                <span class="money">{{item.price == 0?'免费':'¥'+item.price}}</span>
                <span class="number">
                  <i class="el-icon-user-solid"></i>
                  {{item.count}}
                </span>
              </div>
            </div>
          </router-link>
        </ul>
      </div>
    </div>

    <div class="makeclasee" v-if="indexdata.offline">
      <div class="containers">
        <h2 class="newtitle">预约课程</h2>
        <ul class="pubilcul clearfix on">
          <router-link
            tag="li"
            :to="{path:'/detailsclass',query:{id:item.id}}"
            v-for="(item) in indexdata.offline"
            :key="item.id"
            :data-id="item.id"
          >
            <div class="pic">
              <img :src="item.imgUrl" alt srcset />
              <div class="type">预约课</div>
            </div>
            <div class="infos">
              <h3>{{item.title}}</h3>
              <div class="spans clearfix">
                <span class="money">{{item.price == 0?'免费':'¥'+item.price}}</span>
                <span class="number">
                  <i class="el-icon-user-solid"></i>
                  {{item.count}}
                </span>
              </div>
            </div>
          </router-link>
        </ul>
      </div>
    </div>

    <div
      class="famousteacher"
      style="background-image: url(http://web.wit100.net/yunmipcimg/bg_35.jpg);"
      v-if="indexdata.teacher"
    >
      <h2>名师推荐</h2>
      <div class="tuis containers">
        <div class="swiper-container" ref="teachers">
          <ul class="clearfix swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item) in indexdata.teacher"
              :key="item.id"
              :data-id="item.id"
            >
              <router-link tag="li" :to="{path:'/teacherdetails',query:{id:item.id}}">
                <img :src="item.avatar" alt srcset />
                <div class="name">{{item.name}}</div>
                <div class="spans">
                  <span>{{item.courseCount}}门课</span>
                  <span>{{item.collectCount}}人关注</span>
                </div>
                <p>{{item.describe}}</p>
              </router-link>
            </div>
          </ul>
          
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
      <div class="bg"></div>
    </div>

    <div class="hot" v-if="indexdata.article">
      <div class="containers">
        <h2>热门资讯</h2>
        <ul class="clearfix">
          <router-link
            tag="li"
            :to="{path:'/infordetails',query:{id:item.id}}"
            v-for="(item,index) in indexdata.article"
            :key="item.id"
            :data-id="item.id"
            v-if='index<=2'
          >
            <div class="pic">
              <img :src="item.image" alt srcset />
            </div>
            <h3>{{item.title}}</h3>
            <p>{{item.describe}}</p>
          </router-link>
        </ul>
        <router-link tag="div" to="/information" class="more">查看更多</router-link>
      </div>
    </div>

    <footers />
  </div>
</template>

<script>
import {
  Input,
  Tag,
  Button,
  Avatar,
  Container,
  Aside,
  Main,
  Tabs,
  TabPane,
  Icon,
  Carousel,
  CarouselItem
} from "element-ui";
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import utilFile from "@/ace/ace.js";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "index",
  components: {
    headers,
    footers,
    [Input.name]: Input,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Avatar.name]: Avatar,
    [Container.name]: Container,
    [Aside.name]: Aside,
    [Main.name]: Main,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Icon.name]: Icon,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  data() {
    return {
      input: "",
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      name: 0,
      indexdata: "", //首页数据
      fenlei: "", //分类
      fenleiindex: -1 //分类下标
    };
  },
  methods: {
    hoverfun() {},
    fenleiActive(index) {
      this.fenleiindex = index;
    },
    fenleiremoveActive(index) {
      this.fenleiindex = index;
    },
    index() {
      //首页数据请求
      var data = {
        terminalType: "pc",
        version: "1.0.0"
      };

      data = utilFile.encrypt(JSON.stringify(data));

      this.$axios({
        method: "post",
        url: `/index/home.data?parameter=${data}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
        this.indexdata = totaldata;
        this.live_banner();
        this.teacher_banner();
      });
    },
    //最近直播
    live_banner() {
      this.$nextTick(() => {
        new Swiper(this.$refs.live, {
          loop: false,
          // 如果需要分页器
          navigation: {
            nextEl: ".lately .swiper-button-next",
            prevEl: ".lately .swiper-button-prev"
          },
          spaceBetween: 30,
          slidesPerView: 3,
          centeredSlides: false,
          initialSlide: 0,
          autoplay: false,
          observer: true,
          observeParents: true
        });
      });
    },
    //教师
    teacher_banner() {
      this.$nextTick(() => {
        new Swiper(this.$refs.teachers, {
          loop: false,
          // 如果需要分页器
          navigation: {
            nextEl: ".famousteacher .swiper-button-next",
            prevEl: ".famousteacher .swiper-button-prev"
          },
          spaceBetween: 13,
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 0,
          initialSlide: 0,
          autoplay: false,
          observer: true,
          observeParents: true
        });
      });
    },
    //分类
    fenleifunc() {
      this.$axios({
        method: "post",
        url: `/index/home.category`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));

        this.fenlei = totaldata;
      });
    },
    //banner跳转
    bannerto(type, value) {
      if (type == 0) {
        //外链

        window.location.href = value;
      } else if (type == 1 || type == 2) {
        //课程  1是课程     2是线下课程
        this.$router.push({
          path: "/detailsclass",
          query: {
            id: value,
            type: type == 2 ? 3 : null
          }
        });
      } else if (type == 3) {
        //老师

        this.$router.push({
          path: "/teacherdetails",
          query: {
            id: value
          }
        });
      } else if (type == 4) {
        //机构

        this.$router.push({
          path: "/medetails",
          query: {
            id: value
          }
        });
      }
    }
  },
  mounted() {
    this.index();
    this.fenleifunc();
  }
};
</script>

<style scoped>
.banner {
  margin-top: 34px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 16px 1px rgba(0, 0, 0, 0.3);
  margin-bottom: 47px;
}

.banner .spanlist {
  background-color: #2b343b;
  position: relative;
  box-sizing: border-box;
  padding-left: 14px;
  padding-top: 15px;
  padding-bottom: 15px;
  height: 400px;
}

.banner .spanlist {
  width: 222px;
  overflow: hidden;
  overflow-y: auto;
}

.banner .spanlist::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*对垂直流动条有效*/
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px; /*对水平流动条有效*/
}

.banner .spanlist::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}

.banner .spanlist::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

.banner .spanlist span {
  color: rgba(255, 255, 255, 0.6);
  display: block;
  width: 100%;
  font-size: 14px;
  line-height: 51px;
  box-sizing: border-box;
  padding-right: 23px;
  text-align: justify;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px 0 0 6px;
  box-sizing: border-box;
  padding-left: 12px;
  cursor: pointer;
  height: 51px;
  
}

.banner .spanlist span em{
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

.banner .spanlist span:hover {
  background-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 1);
  display: block;
}


.banner span:hover .coner {
  background-color: rgba(255, 255, 255, 1);
  display: block;
  
}

.banner .spanlist span i {
  float: right;
  line-height: 51px;
}

.banner .main {
  width: 974px;
  height: 400px;
}

.banner .coner {
  position: absolute;
  height: 100%;
  background-color: #fff;
  width: 770px;
  left: 222px;
  top: 0;
  display: block;
  z-index: 100;
  overflow: hidden;
  cursor: pointer;
}

.banner .coner .conernei {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}

.banner .coner .conert {
  height: 45%;
  background-color: #fff;
  box-sizing: border-box;
  padding-left: 37px;
}
.banner .coner .conert h3 {
  text-align: left;
  font-size: 13px;
  color: #1b1f22;
  margin-bottom: 24px;
  margin-top: 30px;
  font-weight: 600;
}

.banner .coner .alist {
  width: 615px;
}

.banner .coner .alist em {
  float: left;
  font-size: 13px;
  color: #1b1f22;
  margin-right: 21px;
  margin-bottom: 22px;
}

.banner .coner .alist em:hover {
  color: #38a0ff;
}
.banner .conerb {
  background-color: #f8fafc;
  height: 55%;
  box-sizing: border-box;
  padding-left: 37px;

  padding-top: 30px;
}

.banner .conerb dd {
  float: left;
}

.banner .conerb dd .pic {
  float: left;
  width: 70px;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 16px;
  height: 53px;
  margin-bottom: 27px;
}

.banner .conerb dd .pic img {
  min-height: 100%;
}

.banner .conerb dd .infos {
  float: right;
  width: 217px;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 16px;
}

.banner .conerb dd .infos h4 {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.9);
  margin-bottom: 9px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.banner .conerb dd .infos .numbox {
  font-size: 12px;
  color: #000000;
  margin-bottom: 9px;
  text-align: left;
}

.banner .conerb dd .numbox i {
  display: inline-block;
  color: #000000!important;
}

h2.indextitle {
  font-size: 24px;
  color: #1b1f23;
  line-height: 30px;
  text-align: left;
  margin-bottom: 30px;
  margin-top: 47px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight:600;
}

h2.indextitle span {
  font-size: 14px;
  color: #686a77;
  margin-left: 18px;
  font-weight:300;
}

.lately {
  box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  position: relative;
}

.lately .containers {
  position: relative;
}

.lately li {
  float: left;
  width: 100%;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  box-shadow: 0 0px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 44px;
  padding-bottom: 20px;
  position: relative;
}

.lately li .infos {
  float: left;
}

.lately li .time {
  font-size: 14px;
  color: #000000;
  margin-top: 34px;
  margin-bottom: 14px;
  text-align: left;
}

.lately li h3 {
  font-size: 15px;
  color: #2c2c2c;
  margin-bottom: 13px;
  text-align: left;
}

.lately li .name {
  font-size: 12px;
  color: #878787;
  margin-bottom: 18px;
  text-align: left;
}

.lately li .money {
  font-size: 20px;
  color: #f13232;
  margin-right: 22px;
}

.lately li .people {
  font-size: 14px;
  color: #878787;
  margin-right: 22px;
}

.lately li .people i {
  color: #c9cbd1;
}

.lately li .pic {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin-top: 36px;
}

.lately li .pic img {
  height: 100%;
}

.lately li .type {
  font-size: 12px;
  color: #fff;
  border-radius: 0 0 8px 0;
  background-color: #4099ff;
  position: absolute;
  left: 0;
  top: 0;
  padding: 4px 7px;
}
.lately .swiper-slide {
  padding-right: 0px;
}

.lately .imglist img {
  width: 32%;
  margin-right: 1.9%;
  float: left;
  margin-bottom: 44px;
}

.lately .imglist img:last-of-type {
  margin-right: 0%;
}

.lately .swiper-button-next,
.lately .swiper-button-prev {
  top: 51%;
}

.lately .swiper-button-next:after,
.lately .swiper-button-prev:after {
  color: #ccc;
  font-size: 30px;
  font-weight: bold;
}

.lately .swiper-button-prev,
.lately .swiper-container-rtl .swiper-button-next {
  left: -40px;
}

.lately .swiper-button-next.swiper-button-disabled,
.lately .swiper-button-prev.swiper-button-disabled {
  right: -40px;
  opacity: 0;
}

.lately .swiper-button-next,
.lately .swiper-container-rtl .swiper-button-prev {
  right: -40px;
}

.selectedclass {
  background-color: #f9fafc;
  padding-bottom: 54px;
  overflow: hidden;
}

.makeclasee {
  background-color: #f9fafc;
}

.newclass {
  box-shadow: 0 0 6px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background-color: #FFF;
}

h2.newtitle {
  text-align: left;
  margin-top: 44px;
  margin-bottom: 30px;
  font-weight: 600;
}

.pubilcul li {
  float: left;
  width: 19%;
  margin-right: 1.25%;
  margin-bottom: 30px;
  background-color: #fff;
  padding-bottom: 15px;
  cursor: pointer;
}

.pubilcul li:nth-of-type(5n) {
  margin-right: 0;
}

.pubilcul li .pic {
  height: 130px;
  overflow: hidden;
}

.pubilcul li .pic img {
  min-height: 100%;
}

.pubilcul li .infos {
  box-sizing: border-box;
  padding-left: 15px;
  padding-right: 12px;
}

.pubilcul li .infos h3 {
  font-size: 16px;
  color: #1b1f22;
  margin-top: 10px;
  margin-bottom: 29px;
  text-align: left;
  line-height: 1.5em;
  height: 52px;
  font-weight: 600;
}

.pubilcul li .infos .money {
  float: left;
  font-size: 20px;
  color: red;
  line-height: 20px;
}

.pubilcul li .infos .number {
  float: right;
  font-size: 14px;
  color: #878787;
  line-height: 20px;
}

.pubilcul li .infos .number i {
  color: #c9cbd1;
}

.pubilcul.on li {
  width: 23%;
  margin-right: 2.6%;
}

.pubilcul.on li:nth-of-type(4n) {
  margin-right: 0;
}

.pubilcul.on li .pic {
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.pubilcul.on li .pic .type {
  font-size: 14px;
  color: #fff;
  line-height: 2em;
  padding: 0 10px;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 11px;
  top: 10px;
}

.famousteacher {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  position: relative;
  overflow: hidden;
  min-height: 560px;
}

.famousteacher h2 {
  text-align: center;
  font-size: 30px;
  color: #fff;
  margin-top: 50px;
  margin-bottom: 42px;
  position: relative;
  z-index: 100;
}

.famousteacher li {
  width: 100%;
  box-sizing: border-box;
  padding: 0 43px;
  position: relative;
  z-index: 100;
  cursor: pointer;
}

.famousteacher li img {
  width: 90px;
  height: 90px;
  margin: auto;
  border-radius: 50%;
  margin-bottom: 24px;
}

.famousteacher li .name {
  font-size: 18px;
  color: #fff;
  margin-bottom: 13px;
}

.famousteacher li .spans {
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin-bottom: 20px;
}

.famousteacher li .spans span {
  margin: 0 5px;
}

.famousteacher li p {
  font-size: 14px;
  color: #fff;
  line-height: 1.5em;
  text-align: left;
}

.famousteacher .bg {
  background-color: rgba(0, 88, 208, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.famousteacher .swiper-button-next:after,
.famousteacher .swiper-button-prev:after {
  color: #ccc;
  font-size: 30px;
  font-weight: bold;
}

.famousteacher .swiper-button-next.swiper-button-disabled,
.famousteacher .swiper-button-prev.swiper-button-disabled {
  opacity: 0;
}

.famousteacher .tuis{
  position: relative;
}
.famousteacher .swiper-button-next, 
.famousteacher .swiper-container-rtl .swiper-button-prev{
  right: -17px;
}

.famousteacher .swiper-button-prev, 
.famousteacher .swiper-container-rtl .swiper-button-next{
  left: -17px;
}


.hot h2 {
  font-size: 24px;
  color: #1b1f22;
  margin-top: 46px;
  margin-bottom: 30px;
  text-align: left;
  font-weight: 600
}

.hot li {
  float: left;
  width: 31%;
  margin-right: 3.4%;
  cursor: pointer;
}

.hot li:nth-of-type(3n) {
  margin-right: 0;
}

.hot li .pic {
  height: 200px;
  margin-bottom: 25px;
}

.hot li .pic img {
  min-height: 100%;
}

.hot li h3 {
  text-align: left;
  font-size: 18px;
  color: #000000;
  margin-bottom: 16px;
}

.hot li p {
  font-size: 14px;
  color: #999999;
  line-height: 1.5em;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.more {
  font-size: 22px;
  color: #38a0ff;
  text-align: center;
  border: 1px solid #38a0ff;
  border-radius: 3px;
  margin: auto;
  width: 256px;
  line-height: 56px;
  margin-top: 56px;
  margin-bottom: 80px;
  cursor: pointer;
}
</style>

<style>
.banner .el-carousel {
  height: 100%;
}

.banner .el-carousel__container {
  height: 100%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.banner .main .el-carousel__indicators--horizontal {
  right: 24px;
  left: auto;
}

.banner .main .el-carousel__button {
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 50%;
}

.banner
  .main
  .el-carousel__indicator--horizontal.is-active
  .el-carousel__button {
  width: 20px;
  border-radius: 50px;
}
</style>